import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useEffect, useRef, useState } from "react";
import { IconElement } from "./components/IconElement";
import { useThrottledWidthObserver } from "@/hooks/useThrottledWidthObserver";
export const SimpleAccordion = ({ titleContent, bodyContent, onToggle, paddingTop = "spacing.0", paddingBottom = "spacing.4", }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const contentRef = useRef(null);
    const [height, setHeight] = useState("0px");
    const handleToggle = () => {
        const newState = !isExpanded;
        setIsExpanded(newState);
        onToggle === null || onToggle === void 0 ? void 0 : onToggle(newState);
    };
    useEffect(() => {
        if (isExpanded && contentRef.current) {
            setHeight(`${contentRef.current.scrollHeight}px`);
        }
        else {
            setHeight("0px");
        }
    }, [isExpanded]);
    useThrottledWidthObserver(contentRef, () => {
        if (isExpanded && contentRef.current)
            setHeight(`${contentRef.current.scrollHeight}px`);
    });
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "space-between", onClick: handleToggle, "aria-expanded": isExpanded, width: "100%", overflow: "hidden", cursor: "pointer", paddingBottom: isExpanded ? "spacing.4" : paddingBottom, paddingTop: paddingTop, children: [titleContent, _jsx(IconElement, { isExpanded: isExpanded })] }), _jsx(Box, { ref: contentRef, height: height, overflow: "hidden", transitionDuration: "unsafe_component.accordion.motionDuration", transitionTimingFunction: "unsafe_component.accordion.motionEasing", children: bodyContent })] }));
};
